import { render, staticRenderFns } from "./ScoutResumeCardDetail.vue?vue&type=template&id=58793c72"
import script from "./ScoutResumeCardDetail.vue?vue&type=script&lang=js"
export * from "./ScoutResumeCardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports